module.exports = "/_next/static/images/soccer@3x-84dbf2ca637651659353114a53b524be.png";